{
    "title": "Add New User",
    "user": {
        "firstName": {
            "title": "First Name",
            "class": "form-group col-6 lg:col-4",
            "inputType":"text"
            
        },
        "lastName": {
            "title": "Last Name",
            "class": "form-group col-6 lg:col-4",
            "inputType":"text"

        },
        "username": {
            "title": "User Name",
            "class": "form-group col-6 lg:col-4",
            "inputType":"text"

        },
        "email": {
            "title": "Email",
            "class": "form-group col-6 lg:col-4",
            "inputType":"email"

        },
        "mobileNo":{
            "title": "Mobile Number",
            "class": "form-group col-6 lg:col-4",
            "inputType":"number"
        },
        "department":{
            "title": "Department",
            "class": "form-group col-6 lg:col-4"
        },
        "division":{
            "title": "Division",
            "class": "form-group col-6 lg:col-4"
        },
        "appPassword":{
            "title": "Application Password",
            "class": "form-group col-6 lg:col-4",
            "inputType":"text"
        },
        "mCountryCode": {
            "title": "Country Code"
        },
        "cancelBtn":{
            "title": "Cancel"
        },
        "addBtn":{
            "title":"Add"
        },
        "placeHolder":{
            "firstName":{
                "label":"Enter First Name"
            },
            "lastName":{
                "label": "Enter Last Name"
            },
            "userName":{
                "label":"Enter UserName"
            },
            "email":{
                "label": "Email"
            },
            "mobileNo":{
                "label":"Enter mobile No"
            },
            "department":{
                "label":"Select or enter Department"
            },
            "division":{
                "label":"Select or enter Division"
            }
        }
    }
}